export default class TicketFilterEntity {
    static getEntityData(elem: any) {
        return {
            uuid: elem.querySelector("#ticket_filter_uuid") ? (elem.querySelector("#ticket_filter_uuid") as HTMLInputElement).value : null,
            filter: (elem.querySelector("#ticket_filter_filter") as HTMLInputElement).value,
            order: (elem.querySelector("#ticket_filter_order") as HTMLInputElement).value,
            visibility: (elem.querySelector("#ticket_filter_visibility") as HTMLInputElement).value,
            name: (elem.querySelector("#ticket_filter_name") as HTMLInputElement).value,
        }
    }
}